import { useQuery } from '@tanstack/react-query'
import { featureCollection } from '@turf/helpers'
import { Feature } from 'geojson'
import { useInventory } from '..'
import { getBoundaryFeature } from '../getBoundaryFeature'

export const useInventoryFeatures = (inventoryId?: string) => {
  const inventory = useInventory(inventoryId)

  return useQuery({
    queryKey: ['inventory_geometries', inventoryId],
    queryFn: async () => {
      if (!inventory.data) return

      const boundaries = inventory.data.item.boundaries
      const boundaryGeometries = await Promise.all(boundaries.map(getBoundaryFeature))

      return featureCollection(boundaryGeometries.filter(Boolean) as Feature[])
    },

    enabled: !!inventory.data,
  })
}
